import * as Colors from './colors';
import '@fontsource/fira-code';
import '@fontsource/open-sans';

export const fontFamilies = {
  heading: 'Montserrat, Helvetica, sans-serif',
  body: "'Open Sans', Helvetica, Arial, sans-serif",
  code: "'Fira Code', monospace"
};

export const typeScale = {
  h1: '1.5rem',
  h2: '1.5rem',
  h3: '1.25rem',
  h4: '1.25rem',
  h5: '1rem',
  h6: '1rem',
  body1: '14px',
  body2: '12px',
  label1: '12px',
  label2: '14px',
  caption: '12px'
};

/**
 * Common typographical styles from Portal Style Guide
 */
const TextStyles = {
  h1: {
    fontFamily: fontFamilies.heading,
    fontSize: typeScale.h1,
    fontWeight: 600
  },
  h2: {
    fontFamily: fontFamilies.heading,
    fontSize: typeScale.h2,
    fontWeight: 300,
    color: Colors.blue[600]
  },
  h3: {
    fontFamily: fontFamilies.heading,
    fontSize: typeScale.h3,
    fontWeight: 600,
    textTransform: 'uppercase'
  },
  h4: {
    fontFamily: fontFamilies.heading,
    fontSize: typeScale.h4,
    fontWeight: 300,
    textTransform: 'uppercase'
  },
  h5: {
    fontFamily: fontFamilies.heading,
    fontSize: typeScale.h5,
    fontWeight: 600
  },
  h6: {
    fontFamily: fontFamilies.heading,
    fontSize: typeScale.h6,
    fontWeight: 300
  },
  label1: {
    fontFamily: fontFamilies.heading,
    color: Colors.neutral[600],
    fontWeight: 300,
    fontSize: typeScale.label1,
    margin: 0
  },
  label2: {
    fontFamily: fontFamilies.heading,
    color: Colors.neutral[600],
    fontWeight: 300,
    fontSize: typeScale.label2,
    margin: 0
  },
  label4: {
    fontFamily: fontFamilies.heading,
    fontWeight: 200,
    fontSize: 11,
    color: Colors.neutral[600]
  },
  body1: {
    fontFamily: fontFamilies.body,
    color: Colors.neutral[700],
    fontWeight: 300,
    fontSize: typeScale.body1,
    letterSpacing: 0.3,
    lineHeight: 1.43
  },
  body2: {
    fontFamily: fontFamilies.body,
    color: Colors.neutral[600],
    fontWeight: 400,
    fontSize: typeScale.body2,
    lineHeight: 1.33
  },
  caption: {
    fontFamily: fontFamilies.body,
    color: Colors.neutral[600],
    fontWeight: 300,
    fontSize: typeScale.caption
  }
};

export default TextStyles;
